type Fields = Record<string, string | number | boolean>

/** Compact before→after diff for a `bed_inventory.update` audit row. The audit
 * row stores only the fields that changed, so we list each one as
 * `<field>: <before> → <after>`. Text only — readable without colour. */
export function BedDiff({ before, after }: { before: Fields; after: Fields }) {
  const keys = Array.from(
    new Set([...Object.keys(before), ...Object.keys(after)]),
  )
  if (keys.length === 0) {
    return <span className="text-ink-3">—</span>
  }
  return (
    <ul className="flex flex-col gap-0.5">
      {keys.map((k) => (
        <li key={k} className="tabular-nums">
          <span className="text-ink-3">{k.replace(/_/g, ' ')}</span>{' '}
          <span>{String(before[k] ?? '—')}</span>
          <span className="text-ink-3"> → </span>
          <span className="font-medium text-ink-1">
            {String(after[k] ?? '—')}
          </span>
        </li>
      ))}
    </ul>
  )
}
